import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';

import { TransactionStore } from '../../store/transaction.store';
import { UtilityService } from '../services/utility.service';

export const transactionDashboardResolver: ResolveFn<Promise<boolean>> = async (route, state) => {
  const store = inject(TransactionStore);
  const router = inject(Router);
  const utility = inject(UtilityService);
  if (!store.isRolesInitialized()) {
    store.getRoles();
  }

  await utility.checkPreRequisites(() => !!store.roles().length || store.isRolesInitialized());

  if (!store.roles().length) {
    router.navigate(['/no-records']);
    return false;
  }

  return true;
};
